import { useState, useEffect } from 'react'

export function usePagination<T>(items: T[], pageSize = 25) {
  const [page, setPage] = useState(1)

  // Reset to page 1 whenever the filtered set size changes
  useEffect(() => { setPage(1) }, [items.length])

  const total = items.length
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const safePage = Math.min(page, totalPages)
  const start = (safePage - 1) * pageSize
  const paged = items.slice(start, start + pageSize)

  return { page: safePage, setPage, totalPages, total, paged, pageSize, start }
}
